import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './tabs.scss';

// Icons
// ---------------------
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron_left_black_24dp.svg';

export const Tabs = ({
  data,
  allowDeselect = false,
  aria,
  readContent = false,
  ...props
}) => {
  const [tabs, setTabs] = useState(data);
  const navigate = useNavigate();

  const handleTabClick = (e, index) => {
    setTabs(
      tabs.map((tab, i) => {
        if (i === index) {
          if (!tab.active) {
            tab.active = true;
            if (tab.path) {
              navigate(`${tab.path}`);
            }
          } else if (tab.active && allowDeselect) {
            tab.active = false;
          }
        } else {
          tab.active = false;
        }
        return tab;
      })
    );
  };

  return (
    <div className={`tabs-component`}>
      <div
        role="tablist"
        aria-label={aria}
        className={`tabs ${
          tabs.filter((tab) => tab.active).length === 0 ? 'inactive' : ''
        }`}
      >
        {tabs.map((item, i) => {
          return (
            <button
              key={`tab-${i}`}
              role="tab"
              aria-controls={'tab-content-' + i}
              aria-selected={item.active}
              aria-label={`View ${item.label}`}
              className={`tab stripped-button ${item.active ? 'active' : ''}`}
              onClick={(e) => handleTabClick(e, i)}
            >
              <div className="label">{item.label}</div>
              <div className="chevron">
                <ChevronIcon />
              </div>
            </button>
          );
        })}
      </div>
      <div className="tab-content">
        {tabs.map((item, i) => {
          return (
            <div
              key={`tab-content-${i}`}
              id={'tab-content-' + i}
              role="tabpanel"
              className={!item.active ? 'display-none' : ''}
              aria-live={readContent && item.active ? 'polite' : 'off'}
              tabIndex={readContent ? 0 : null}
            >
              {item.content}
            </div>
          );
        })}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array,
  allowDeselect: PropTypes.bool,
  aria: PropTypes.string,
};
